<template>
	<div class="knowledge-points">
		

		<div class="preview-head">
			<div class="knowledge-points-head">
				<a @click="goBack()"><i class="el-icon-arrow-left"></i>返回</a>
				<div class="knowledge-points-head-op">
					<span>试卷范围:</span>

					<template>
					  <el-select v-model="manual.grade" placeholder="请选择年级" @change="setRange($event, 'grade')">
					    <el-option
					      v-for="(item, index) in gradeLsit"
					      :key="index"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>
					</template>

					<template>
					  <el-select v-model="manual.subject" placeholder="请选择科目"  @change="setRange($event, 'subject')">
					    <el-option
					      v-for="(item, index) in subjectLsit"
					      :key="index"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>
					</template>

					<template>
					  <el-select v-model="manual.edition" placeholder="请选择版本"  @change="setRange($event, 'edition')">
					    <el-option
					      v-for="(item, index) in editionList"
					      :key="index"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>
					</template>

					<template >
					  <el-select v-model="manual.material" placeholder="请选择教材">
					    <el-option
					      v-for="(item, index) in materialList"
					      :key="index"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>
					</template>

					
				</div>
				<div class="knowledge-points-head-op knowledge-head-op" >
					<span>试卷类型:</span>
					<template >
					  <el-select v-model="manual.type " placeholder="请选择试题类型">
					    <el-option
					      v-for="(item, index) in getTestTypeList"
					      :key="index"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					  </el-select>
					</template>
				</div>
			</div>
			
			<div class="preview-head-btn">
				<el-button type="primary"  @click="changeVisible" v-preventReClick>提交</el-button>
				
			</div>
		</div>

		<div class="knowledge-warp"  :class="setClass">
			
			<div class="knowledge-warp-l">

				<input type="checkbox" name="type" v-model="classObject.isLeft">
				
				<knowledgeLeft ref="knowledgeLeft"></knowledgeLeft>

			</div>

			<div class="knowledge-warp-r">

				
				<input type="checkbox" name="type" v-model="classObject.isRight">
				<knowledgeRigth ></knowledgeRigth>

			</div>
		</div>

		<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			width="30%" customClass="dialog-box"
			:close-on-click-modal="false">
				<div class="authority">
					<div>
						<span>
							<input type="radio" name="radio" v-model="manual.authority" value="1">
							<i class="el-icon-circle-check"></i>
						</span>
						<p>公开</p>
					</div>
					<div>
						<span>
							<input type="radio" name="radio" v-model="manual.authority" value="0">
							<i class="el-icon-circle-close"></i>
						</span>
						<p>私有</p>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary"  plain @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="testChang">确 定</el-button>
				</span>
		</el-dialog>

	</div>
</template>


<script>

	// let manualObj = JSON.parse(sessionStorage.getItem('manualObj'));
	import bus  from  './../base/eventBus.js'
	import knowledgeLeft from './knowledge-points-l.vue';
	import knowledgeRigth from './knowledge-points-r.vue'
	export default{
		components: { knowledgeLeft, knowledgeRigth},
		data(){
			return{
				headClassList: null,
				chapterID: '',	/*章节id*/
				knowledgeID: '', /*知识点id*/
				manual: {
					grade: '', 		/*年级id*/
					subject: '',    /*科目id*/
					edition: '', 	/*版本id*/
					material: '',	/*教材*/
					authority: 0,
					type:''
				},
				gradeLsit: [], 		/*年级列表*/
				subjectLsit: [], 	/*科目列表*/
				editionList: [], 	/*版本列表*/
				materialList: [],	/*教材*/
				questionArray: [],
				getTestTypeList: [],
				dialogVisible: false,
				
				classObject: {	/*左右收起 & 展开*/
					isLeft: false,
					isRight: false,
				}

			}
		},
		computed: {
			setClass(){
				 if(this.classObject.isLeft == true && this.classObject.isRight == true){
					return 'knowledge-sidebarQ'
				}else if (this.classObject.isLeft == true && this.classObject.isRight == false) {
					return 'knowledge-sidebarL'
				}else if(this.classObject.isRight == true && this.classObject.isLeft == false){
					return 'knowledge-sidebarR'
				}
			}
		},
		created(){

		
			bus.$on("setQuestion", (questionTyle) => {
				this.questionArray = questionTyle
			});
		},
		mounted(){
			this.headClassList = document.querySelector('#trunk').classList;
			this.headClassList.add('hidden-knowledge')


			this.$nextTick(()=>{

				setTimeout(()=>{
					let manualObj = JSON.parse(sessionStorage.getItem('manualObj'));
					this.manual.grade =  manualObj.grade;	/*年级id*/
					this.manual.subject =  manualObj.subject;    /*科目id*/
					this.manual.edition =  manualObj.edition; 	/*版本id*/
					this.manual.material =  manualObj.course_id;	/*教材*/
					this.manual.type =  manualObj.type  ? manualObj.type : '' ;	/*教材*/

					this.manual.type == 0 ? '' : this.manual.type

					this.getGrade()
					this.getSubject()
					this.getEdition()
					this.getMaterial()
					this.getTestType()
				}, 800);

				
				grade_id: 6
				subject_id: 1
				version_id: 1
			})

		},
		destroyed(){
			this.headClassList.remove('hidden-knowledge')
			sessionStorage.removeItem('manualObj')
		},
		methods: {
			/*题目范围:*/
			topicScope(){

				let success = (res =>{
					// this.$message.success(res.msg)
				});

				let testID = ''
				if (this.$route.query.id) {
					testID = this.$route.query.id
				}else{
					testID = this.$route.query.edit
				}

				let params = {
					id: testID,/*试卷名*/
					create_id: 		this.$g.user_id,
					grade_id:  		this.manual.grade,
					subject_id:  	this.manual.subject,
					version_id:  	this.manual.edition,
					course_id: 		this.manual.material,
					source_id: 		this.manual.type,
					authority: 0,
					status: 1,
				};

				this.$ajax.put('api/newtest/save_test', params, {func: {success: success}})

				/*this.$ajax({
					url: 'api/newtest/save_test',
					method: 'post',
					params: params,
					func: {success: success}
				})*/
			},
			/*
				提交试卷数据
			*/
			changeVisible(){

				if (this.manual.grade == '' || this.manual.subject == '' ||  this.manual.edition == '')  {
					return this.$message.error("请选择题目范围")
				}

				if (this.questionArray.length === 0) {return this.$message.error("请组卷再提交")};
				// this.dialogVisible = true;
				this.topicScope()
				this.testChang()
			},
			/**
			 * 试卷的试题排序
			 * @DateTime 2019-08-13T15:27:53+0800
			 * @return   {[type]}                 [description]
			 */
			testChang(){
				let [idex, questionList] = [1, []]
				this.questionArray.forEach((item, index) =>{
					item.children.forEach((child, list) =>{
						questionList.push({
							'question_id': child.id,
							'score': child.score,
							'sort': idex++
						})
					})
				});


				let success = (res=>{
					// this.$message.success(res.msg)
					this.submitTest()
				});

				let testID = ''

				if (this.$route.query.id) {
					testID = this.$route.query.id
				}else{
					testID = this.$route.query.edit
				}

				let params = {test_id: testID, question_list: questionList};
				this.$ajax.put('api/newtest/change_test', params, {func: {success: success}})
			},
			/**
			 * 提交新建的试卷
			 * @DateTime 2019-08-12T14:29:15+0800
			 * @return   {[type]}                 [description]
			 */
			submitTest(){
				let status = '';
				if (this.manual.authority == 1) {
					status = 3
				}else if (this.manual.authority ==  0){
					status = 1
				}

				let testID = ''
				if (this.$route.query.id) {
					testID = this.$route.query.id
				}else{
					testID = this.$route.query.edit
				}

				let success = (res =>{
					// this.$message.success(res.msg)
					this.dialogVisible = false

					if (this.$route.query.points == 1) {
						this.$router.push({path: '/test/test-paper', query: {id: testID, authority: 2}})
					}else{
						this.$router.push({path: '/test/preview-test', query: {id: testID, 'points': 2}})
					}

					
				});

				let params = {
					id: testID,/*试卷名*/
					status: status,/*状态 1正常 0删除 2未通过 3未处理*/
					authority: this.manual.authority,/*是否公开 1 公开 2不公开*/
					// difficulty_id: ,/*难度id*/
				};

				this.$ajax.put('api/newtest/save_test', params, {func: {success: success}})
			},
			
			/**
			 * 请求年级列表数据
			 * @DateTime 2019-07-22T14:45:06+0800
			 */
			getGrade(){
				let success = (res=>{
					this.gradeLsit = res.data;
				});

				let params = {
					level:3,
					// pid:0,
					direction:'balance',
				};

				this.$ajax({
					url: 'api/org/org',
					method: 'get',
					params: params,
					func: { success: success}
				})
			},
			/**
			 * 请求科目数据
			 * @DateTime 2019-07-22T14:53:30+0800
			 */
			getSubject(){
				let success = (res=>{
					this.subjectLsit = res.data
				});

				let params = {
					type:2,
					org_id: this.manual.grade,
					status:1,
				};

				this.$ajax({
					url: 'api/cate/subject',
					method: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求科目版本
			 * @DateTime 2019-07-22T15:30:28+0800
			 */
			getEdition(){
				let success = (res=>{
					this.editionList = res.data;
				});

				let params = {
					type:2,
					org_id:this.manual.grade,
					sub_id:this.manual.subject,
					status:1
				};

				this.$ajax({
					url: 'api/cate/version',
					methosd: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求教材列表数据
			 * @DateTime 2019-07-22T15:39:04+0800
			 * @return   {[type]}                 [description]
			 */
			getMaterial(){
				let success = (res=>{
					this.materialList = res.data;
				});

				let params = {
					org_id:this.manual.grade,
					sub_id:this.manual.subject,
					ver_id:this.manual.edition,
					status:1
				};

				this.$ajax({
					url: 'api/cate/material',
					method: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求试题类型数据
			 * @DateTime 2019-07-25T14:09:13+0800
			 * @return   {[type]}                 [description]
			 */
			getTestType(){

				let success = (res=>{
					this.getTestTypeList = res.data;
					// if (this.getTestTypeList.length > 0) {
					// 	this.getTestTypeList.unshift({id:0, name: '全部'})
					// }
				});

				let params = {status: 1};

				this.$ajax({
					url: 'api/newtest/get_test_type',
					method: 'get',
					params: params,
					func: { success: success}
				})
			},
			/**
			 * 改变题目范围
			 * @param {String} val 选择的id
			 * @param {String} type
			 * 根据改变当前参数重置相关数据
			 */
			setRange(val,type){
				switch( type ){
					case 'grade': /*年级*/
						this.manual.subject = '';
						this.manual.edition = '';
						this.manual.material = '';

						this.subjectLsit = [];
						this.editionList = [];
						this.materialList = [];
						this.getSubject();
					break;
					case 'subject': /*科目*/
						this.manual.edition = '';
						this.manual.material = '';

						this.editionList = [];
						this.materialList = [];
						this.getEdition();
					break;
					case 'edition': /*版本*/
						this.manual.material = '';
						this.materialList = [];
						this.getMaterial();
					break;
				}
			},
			/**/
			delTest(){

				let len = this.$refs.knowledgeLeft.changQuestionid()
				let success = (res=>{
					this.$router.back(-1)
				});
				this.$ajax({
					url: 'api/test/bind_one_question_to_test',
					method: 'delete',
					params: {
						testid: this.$route.query.edit,
						question_id: len
					},
					func: { success: success}
				})
			},
			goBack(){
				console.log(this.$refs.knowledgeLeft.changQuestionid())
				this.$confirm('返回将不保存当前创建的试卷内容，是否继续？', '提示', {
					cancelButtonText: '取消',
					confirmButtonText: '确定',
					type: 'warning',
					customClass: "test-message"
				}).then(() => {
					/*新建返回删除*/
					if (this.$route.query.id) {
						let success = (res=>{
							this.$router.back(-1)
						});
						this.$ajax({
							url: 'api/test/test_del_one',
							method: 'delete',
							params: {id: this.$route.query.id},
							func: { success: success}
						})
					}else{
						// this.delTest()
						/*编辑返回*/
						this.$router.push('/test/private-library')
					}

				
				}).catch(() => {});
			},
			
		}
	}
</script>